import { Component, OnInit } from '@angular/core';

@Component({
	moduleId: module.id,
	selector: "page-container",
	templateUrl: '../shell-templates/page-container.component.html'
})

export class PageContainerComponent {

	constructor(
	) { }

	ngOnInit(): void {
	}
}



// WEBPACK FOOTER //
// ./src/app/shell/shell-components/page-container.component.ts